import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'InformationBox',
  props: {
  backgroundColor: {
    type: String,
    default: 'var(--c-primary-50)',
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})